import Utils from "./utils-service.js";
import Funnel from "./funnel-service.js";

export default class Disaster {
    constructor(lib) {
        this.ctx = lib.ctx;
        this.router = lib.router;
        this.fs = new Funnel({ ctx: lib.ctx });
    }

    pg_disaster_property_type(payload) {
        console.log(payload);
    }

    pg_disaster_rent_or_own(payload) {
        console.log(payload);
    }

    pg_disaster_existing_policy(payload) {
        console.log(payload);
    }

    pg_disaster_mobile_or_manufactured(payload) {
        console.log(payload);
    }

    pg_disaster_coverage_select(payload) {
        console.log(payload);
    }

    pg_disaster_payment_info(payload) {
        console.log(payload);
    }

    updatePrices(e, input, args) {
        const iuid = 'in_disaster_cost';
        const index = e.target.id.slice(-1);
        const annualPremium = input.options[index].premium;
        const monthlyPremium = (parseFloat(annualPremium) / 12).toFixed(2).toString();

        let string = this.ctx.getters.funnel.elements[iuid].value;

        
        //we need to find a way to make a check for the annualpremium is null or NaN and trigger the fetch of the coverages prices ajax again.
        if (string.includes('%selected_coverage_monthly%')) {
            string = string.replace('%selected_coverage_monthly%', monthlyPremium).replace('%selected_coverage_annual%', annualPremium);
        } else {
            string = string
                .replace(/\$\d+\.\d{2} \/ Monthly Payment/, `$${monthlyPremium} / Monthly Payment`)
                .replace(/\$\d+\.\d{2} \/ Annual Payment/, `$${annualPremium} / Annual Payment`);
        }

        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: iuid, key: 'value', val: string });
    }

    validateCCExpiration(e, input, args) {
        let expMonth;
        let expYear;

        if (input.id === 'in_cc_exp_year') {
            expMonth = this.fs.ctx.getters.funnel.elements.in_cc_exp_month.value;
            expYear = input.value;
        } else {
            expMonth = input.value;
            expYear = this.fs.ctx.getters.funnel.elements.in_cc_exp_year.value;
        }

        const currentDate = new Date();
        const monthMap = {
            'January': 0,
            'February': 1,
            'March': 2,
            'April': 3,
            'May': 4,
            'June': 5,
            'July': 6,
            'August': 7,
            'September': 8,
            'October': 9,
            'November': 10,
            'December': 11
        };

        expMonth = monthMap[expMonth];
        const expDate = new Date(expYear, expMonth + 1, 0);

        if (currentDate > expDate) {
            this.fs.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_cc_exp_valid', key: 'value', val: false });
            this.fs.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: true });
        } else {
            this.fs.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_cc_exp_valid', key: 'value', val: true });
            this.fs.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: false });
        }
    }

    ccBankToggle(e, input, args) {
        if (input.value === 'bank') {
            this.fs.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: false });
        }

        if (input.value === 'cc' && this.fs.ctx.getters.funnel.elements.in_cc_exp_valid.value === false) {
            this.fs.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: true });
        }
    }
}